import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import { InputState } from '../../../../../../components';

type InputControlProps = {
  value: boolean | null;
};

export const InputControl: React.FC<InputControlProps> = ({ value }) => {
  const { t } = useTranslation('channel-details');

  const renderInputContent = () => {
    if (value === null) return <span className="sensor-control-box__status">{t('exalus.sensor.noData')}</span>;

    return <InputState status={value} />;
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" padding="0 10px">
      {renderInputContent()}
    </Stack>
  );
};
